import { supabase } from './supabaseClient';

/**
 * フィードバックをSupabaseに保存（ログイン済みのみ）
 */
export async function saveFeedbackLog({ category, message, childName }) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return; // ゲストは保存しない

  await supabase.from('feedback_logs').insert({
    family_id: session.user.id,
    child_name: childName ?? null,
    category,
    message,
  });
}

/**
 * フィードバック履歴をSupabaseから取得（ログイン済みのみ）
 * @returns {Array} 履歴配列（新しい順）
 */
export async function loadFeedbackLogs() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null; // ゲストはnullを返す（localStorage使用）

  const { data, error } = await supabase
    .from('feedback_logs')
    .select('*')
    .eq('family_id', session.user.id)
    .order('created_at', { ascending: false })
    .limit(20);

  if (error) {
    console.error('フィードバック履歴取得エラー:', error);
    return null;
  }
  return data ?? [];
}
